import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { CommonStyles, CommonTheme } from '../styles/Styles';
import { AppTheme } from '../styles/AppTheme';
import { Link } from 'react-router-dom';
import { ProductTile } from '../components/ProductTile';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { Helper } from '../common/helpers/Helper';
import { EmptyMsgView } from '../components/EmptyMsgView';
import { BreadCrumbs } from '../common/components/BreadCrumbs';
import Grid from '@material-ui/core/Grid';
import { AppHelper } from '../helpers/AppHelper';

export class Groups extends Component {
  constructor(props) {
    super(props)
    this.slug = this.props.match.params ? this.props.match.params.slug : null
    this.state = {
      itemGrp: null,
      feautredProducts: [],
      fetchState: ApiHelper.State.LOADING
    }
  }

  componentDidMount() {
    this.fetchItems()
  }

  fetchItems() {
    const options = {
      method: 'GET',
      authWithKey: true,
      endPoint: ApiHelper.makeUrlPath(['miscs', 'products'], { listSlug: this.slug })
    };

    ApiHelper.call(options, (err, results) => {
      if (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getErrorMsg(err)
        })
        return
      }

      this.breadCrumbs = [
        { title: 'Home', to: '/' },
        { title: 'List' },
      ]

      results.items = results.items ? AppHelper.sortParamsByOrder(results.items) : []

      this.setState({
        itemGrp: results,
        fetchState: ApiHelper.State.READY,
      })
    });
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return <EmptyMsgView msg={this.state.errMsg} />
    } else {
      return this.readyView();
    }
  }

  readyView() {
    return (
      <div className={css(CommonStyles.container)}>
        <div className={css(Styles.container)}>
          <div className={css(Styles.bcContainer)}>
            <BreadCrumbs breadCrumbs={this.breadCrumbs} />
          </div>

          {this.state.itemGrp &&
            <h1
              className={css(Styles.sliderTitle)} >
              {this.state.itemGrp.title}
            </h1>
          }

          {this.state.itemGrp &&
            <h3 className={css([Styles.descrText, Styles.descrTextSpec])} >
              {this.state.itemGrp.descr}
            </h3>
          }

          <div className={css(Styles.listContainer)}>
            <Grid container spacing={2}>
              {this.state.itemGrp && this.state.itemGrp.items && this.state.itemGrp.items.map((item, index) => {
                return (
                  <Grid item md={3} sm={4} xs={12}>
                    <Link
                      key={index}
                      className={css(Styles.link)}
                      to={'/products/' + item.slug}>
                      <ProductTile home={true} item={item} />
                    </Link>
                  </Grid>
                )
              })}
            </Grid>

            {(!this.state.itemGrp || !this.state.itemGrp.items || this.state.itemGrp.items.length === 0) &&
              <EmptyMsgView msg={Helper.getString('emptyList')} />
            }
          </div>
        </div>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '30px',
    '@media (max-width: 767px)': {
      width: CommonTheme.mobViewPort,
      alignSelf: 'center',
      marginTop: '15px',
    },
    '@media(min-width: 768px) and (max-width: 1024px)': {
      width: '95%',
    },
  },
  listContainer: {
    marginTop: 15,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    '@media(max-width: 767px)': {
      justifyContent: 'center'
    },
  },
  link: {
    textDecoration: 'none',
    color: 'black',
  },
  sliderTitle: {
    color: CommonTheme.textColor,
    textAlign: 'left',
    margin: '0px 0px 10px 0px',
    fontSize: 22,
  },
  descrText: {
    color: CommonTheme.white,
    fontSize: '14px',
    textAlign: 'left',
    width: CommonTheme.webViewPort,
    alignSelf: 'flex-start',
    margin: '0px 0px 10px 0'
  },
  descrTextSpec: {
    color: CommonTheme.black,
    width: CommonTheme.mobViewPort,
  },
  bcContainer: {
    marginBottom: 10,
  }
})


// WEBPACK FOOTER //
// ./src/screens/Groups.js